module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.payment_service === 'collector') ? _c('CollectorCheckoutConfirmation') : (_vm.SITE_CONFIG.payment_service === 'klarna') ? _c('KlarnaCheckoutConfirmation') : _vm._e(), _vm._v(" "), _c('OrderCheckForCancellation')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98b8db3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PaymentServiceCheckoutConfirmationPage.vue
// module id = 1002
// module chunks = 0